<section>
  <h2>Ordem de entrada</h2>

  <page-loading *ngIf="loading"></page-loading>

  <ul *ngIf="!loading && animals">
    <li *ngFor="let obj of animals; let idx = index">
      <h4>{{ obj.entrance_order || '-' }}</h4>
      <strong> {{ obj.lot }} - </strong>
      <h5>{{ obj.animal || '-' }}</h5>
    </li>
  </ul>
</section>
